export default "__VITE_ASSET__BpcsG45C__"